module.exports = __webpack_public_path__ + "static/media/bg.97d48aec.png";